import Vue from 'vue';

export default new Vue();



// WEBPACK FOOTER //
// ./groups/event_hub.js